import { useAtom } from '@reatom/npm-react'
import { styled } from 'styled-components'

import { LIMIT_ORDER_STATUS_LABEL_MAP } from '@root/entities/limit-order/ui/constants'
import { useTranslation } from '@root/shared/localization'
import { UnderlineTabs } from '@root/shared/ui-kit'

import { ordersPageStatusAtom } from '../../atoms/mobile'

import type { LimitOrder } from '@root/entities/limit-order'

const STATUSES: Array<LimitOrder.Status> = [
  'active',
  'completed',
  'cancelled',
  'expired',
]

export const OrdersList: React.FC = () => {
  const { t } = useTranslation()
  const [status, setStatus] = useAtom(ordersPageStatusAtom)

  return (
    <Root>
      <TabsContainer>
        <Tabs value={status} onChange={setStatus}>
          {STATUSES.map((orderStatus) => (
            <UnderlineTabs.Tab key={orderStatus} value={orderStatus}>
              {t(LIMIT_ORDER_STATUS_LABEL_MAP[orderStatus])}
            </UnderlineTabs.Tab>
          ))}
        </Tabs>
      </TabsContainer>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Tabs = styled(UnderlineTabs<LimitOrder.Status>)`
  border-bottom: none;

  justify-self: center;
  position: relative;
  bottom: -1px;
`

const TabsContainer = styled.div`
  padding-inline: 16px;
  justify-content: center;
  // TODO: Theme
  border-bottom: 1px solid #050505;
`
